<div class="row" *ngIf="!inviteRequest">
    <div class="login-image">

    </div>
    <div class="login-input">
        <ng-container *ngFor="let userTypeItem of userTypes">
            <label class="radio-container">
                <input type="radio" name="userType" [value]="userTypeItem.UserTypeId" [(ngModel)]="userType"
                    (ngModelChange)="updateUserType()" />
                <span class="radio-item"> <strong>{{userTypeItem.UserTypeDisplay}}</strong></span>

                <div class="radio-desc">
                    {{userTypeItem.UserTypeDescription}}
                </div>
            </label>
            <div dwRow *ngIf="userType == pilotExaminerUserType && userTypeItem.UserTypeId == pilotExaminerUserType">
                <div dwCol="12">
                    <label class="label">DMS Number <i class="fa fa-info-circle"
                            title="You must have a DMS Number to create a Pilot Examiner account"></i></label>
                    <input type="text" class="form-control" [(ngModel)]="dmsNumber" (ngModelChange)="updateDMS()" />
                </div>
            </div>
            <ng-container *ngIf="userType == pilotSchoolUserType && userTypeItem.UserTypeId == pilotSchoolUserType">
                <div dwRow >
                    <div dwCol="12">
                        <label class="label">Flight School <i class="fa fa-info-circle"
                                title="Select your flight school or Other if it is not listed"></i></label>
                                 <dw-search-select-lookup [(ngModel)]="flightSchoolId" (ngModelChange)="updateFlightSchool()" [lookupId]="flightSchoolLookupId"
                                    showBlankOption="true" blankOptionText="Select School" ></dw-search-select-lookup>
                    </div>
                </div>
                <div dwRow [hidden]="!flightSchoolId || flightSchoolId == OtherFlightSchoolId">
                    <div dwCol="12">
                        <dw-loading [show]="validating" [loadingText]="'Validating Flight School...'"></dw-loading>
                        <span class="dw-green" [hidden]="!schoolIsValid || validating">School Validated!</span>
                        <span class="dw-red" [hidden]="schoolIsValid || validating">{{schoolValiationErrorMessage}}</span>
                    </div>
                </div>
                <div dwRow [hidden]="flightSchoolId != OtherFlightSchoolId">
                    <div dwCol="12">
                        <span class="dw-red">Please contact support@pilexos.com to request your flight school be added to the list.</span>
                        <!-- <label class="label">Flight School Name <i class="fa fa-info-circle"
                                title="Enter the name of the Flight School you represent"></i></label>
                        <input type="text" class="form-control" [(ngModel)]="flightSchoolNameOther"
                            (ngModelChange)="updateFlightSchool()" /> -->
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- <label class="radio-container">
            <input type="radio" name="userType" value="newVendor" [(ngModel)]="userType" (ngModelChange)="change()" />
            <span class="radio-item"> <strong>Pilot Examiner</strong></span>

            <div class="radio-desc">
                I am an authorized FAA Pilot Examiner and give checkrides
            </div>
        </label> -->
        <!-- <label class="radio-container">
            <input type="radio" name="userType" value="existingVendor" [(ngModel)]="userType" (ngModelChange)="change()" />
            <span class="radio-item"> <strong>Existing Vendor</strong></span>

            <div class="radio-desc">
                My company is currently working as a Wachter Vendor or have so in the past
            </div>
        </label> -->
    </div>
</div>
